<!-- Форма данных бота из мессенджера MAX: используется и при создании, и при редактировании. -->
<template>
  <form :id="formId" class="max-bot-form" @submit.prevent="submitForm">
    <BaseFormField
      label="Название"
      for-id="max-name"
      required
      :filled="!!formData.name"
      :error="errors.name"
    >
      <base-input
        id="max-name"
        v-model="formData.name"
        placeholder="Например: MAX поддержка"
        :invalid="errors.name"
        @update:modelValue="updateField('name', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Токен бота"
      for-id="max-token"
      required
      :filled="!!formData.token"
      :error="errors.token"
    >
      <base-input
        id="max-token"
        v-model="formData.token"
        :is-password="true"
        placeholder="Токен из кабинета MAX"
        :invalid="errors.token"
        @update:modelValue="updateField('token', $event)"
      />
      <span class="field-hint">
        {{ tokenHint }}
      </span>
    </BaseFormField>
  </form>
</template>

<script>
export default {
  name: "IntegrationMaxBotIntegrationForm",

  props: {
    formId: {
      type: String,
      required: true,
    },
    initialData: {
      type: Object,
      default: null,
    },
  },

  emits: ["save"],

  data() {
    return {
      formData: this.buildFormData(this.initialData),
      errors: {
        name: false,
        token: false,
      },
    };
  },

  watch: {
    initialData(newValue) {
      this.formData = this.buildFormData(newValue);
      this.errors = { name: false, token: false };
    },
  },

  computed: {
    isEditMode() {
      return Boolean(this.initialData?.id);
    },
    tokenHint() {
      if (this.isEditMode) {
        return "Оставьте пустым, если не нужно менять токен бота.";
      }

      return "После сохранения включите бота, чтобы backend зарегистрировал webhook в MAX.";
    },
  },

  methods: {
    buildFormData(data) {
      return {
        name: data?.name || "",
        token: data?.token || "",
        provider_type: data?.provider_type || "max_bot",
      };
    },

    updateField(field, value) {
      this.formData[field] = value || "";
      this.errors[field] = false;
    },

    validateForm() {
      this.errors = { name: false, token: false };

      let isValid = true;
      if (!String(this.formData.name || "").trim()) {
        this.errors.name = true;
        isValid = false;
      }
      if (!this.isEditMode && !String(this.formData.token || "").trim()) {
        this.errors.token = true;
        isValid = false;
      }

      return isValid;
    },

    submitForm() {
      if (!this.validateForm()) return;

      const payload = {
        ...this.formData,
        name: String(this.formData.name || "").trim(),
        token: String(this.formData.token || "").trim(),
      };

      if (this.isEditMode && !payload.token) {
        delete payload.token;
      }

      this.$emit("save", payload);
    },
  },
};
</script>

<style scoped>
.max-bot-form {
  display: flex;
  flex-direction: column;
}

.field-hint {
  color: #777;
  display: block;
  font-size: 13px;
  margin-top: 5px;
}
</style>
